import DOMPurify from "dompurify";

export const sanitizeHtml = (value) =>
  DOMPurify.sanitize(value || "", {
    USE_PROFILES: { html: true },
  });

export default sanitizeHtml;
